import React from 'react'
import moment from 'moment'
import 'moment/locale/zh-cn'
import DateRangeButton from './base'
import Icon from '../icon'
import './index.less'

moment.locale('zh-cn')

const DATE_RANGES = [
  { name: '昨日', value: [moment().subtract(1, 'd'), moment().subtract(1, 'd')], show: true },
  { name: '近7天', value: [moment().subtract(7, 'd'), moment().subtract(1, 'd')], show: true },
  { name: '近15天', value: [moment().subtract(15, 'd'), moment().subtract(1, 'd')], show: true },
  { name: '近30天', value: [moment().subtract(30, 'd'), moment().subtract(1, 'd')], show: true },
  { name: '全部', value: [moment('2019-01-01'), moment()], show: true },
]
export default (props) => {
  const { noneText, startTime, endTime, allowClear = true, ranges, onChange, wrapperClassName, className, textStyle,
    overlayStyle, ...otherProps } = props
  return <DateRangeButton
    hideIcon
    noneText={noneText}
    textStyle={{ ...textStyle }}
    overlayClassName="meinian-datepicker"
    overlayStyle={{ zIndex: 1050, ...overlayStyle }}
    wrapperClassName={`${wrapperClassName}`}
    className={`${className}`}
    buttonClassName="meinian-button primary"
    icon={<Icon type="m-Vxing_xia" style={{ fontSize: '16px' }} />}
    iconUp={<Icon type="m-Vxing_shang" style={{ fontSize: '16px' }} />}
    value={[startTime, endTime]}
    allowClear={allowClear}
    onChange={onChange}
    earlistDate="1988-03-01"
    checkAuth={false}
    ranges={ranges || DATE_RANGES}
    getPopupContainer={() => document.querySelector('.meinian')}
    {...otherProps}
  />
}
